import React from 'react'
import { Loader } from '../loader'

const ButtonSecondary = ({children, className, thin, disabled, isLoading, ...props}) => {
  return (
    <button
      className={`bg-secondary rounded uppercase text-center ${thin ? 'p-2' : 'p-4'} w-full text-white font-bold font-accent text-sm ${className} ${disabled ? 'opacity-75' : ''}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {
        isLoading ? (
          <Loader />
        ) : children
      }
    </button>
  )
}

export { ButtonSecondary }
